import { render } from "./RelatorioAnaliseIA.vue?vue&type=template&id=24f5b358"
import script from "./RelatorioAnaliseIA.vue?vue&type=script&lang=js"
export * from "./RelatorioAnaliseIA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__